import React from 'react';
import styled from 'styled-components';
import Dteails from '../Details/Dteails';

const DetailsPage = () => {
    return (
        <>
            <Dteails />

        </>
    );
};

export default DetailsPage;
